import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5"; // Make sure to import this for the document icon
import { FiDownload } from "react-icons/fi"; // Ensure you import this for the download icon

function Debenturesshareholdingtable({ data = [], isSubScribe }) {
  const [openSections, setOpenSections] = useState({
    promoters: true,
    publicOtherThanPromoters: true,
  });

  // const [selectedYear, setSelectedYear] = useState("");
  const [selectedYearPromoters, setSelectedYearPromoters] = useState("");
  const [selectedYearPublic, setSelectedYearPublic] = useState("");

  const toggleSection = (section) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const getAvailableYears = () => {
    const years = Array.from(
      new Set(data.map((item) => item.financialYear))
    ).sort((a, b) => b - a);
    return years;
  };

  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedYearPromoters(years[0]);
      setSelectedYearPublic(years[0]);
    }
  }, [data]);

  const promotersData = data.filter(
    (item) =>
      item.category === "PROMOTERS" &&
      (selectedYearPromoters
        ? item.financialYear === selectedYearPromoters
        : true)
  );

  const publicOtherThanPromotersData = data.filter(
    (item) =>
      item.category === "PUBLIC/OTHER THAN PROMOTERS" &&
      (selectedYearPublic ? item.financialYear === selectedYearPublic : true)
  );

  const formatNumber = (value) => {
    return value ? value.toLocaleString() : "-";
  };

  const renderTable = (data) => (
    <div>
      {data.map((item) => (
        <div key={item.Id} className={styles.referencedoc_main}>
          <div>
            <b>Reference Documents</b>
          </div>

          <div className={styles.referencedoc_container}>
            {item.refDoc ? (
              <>
                <div>
                  {item.refDoc?.MaiinFileName && (
                    <a
                      href={item.refDoc?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item.refDoc?.MaiinFileName}
                    </a>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item.refDoc?.Attachments &&
                    item.refDoc?.Attachments.length > 0 ? (
                      item.refDoc?.Attachments.map((attachment, index) => (
                        <li
                          key={index}
                          className={styles.referencedoc_Attachments}
                        >
                          <IoDocumentTextOutline
                            size={16}
                            style={{
                              marginRight: "8px",
                              color: "#2961EF",
                            }}
                          />
                          <a
                            href={attachment.fileurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "#2961EF",
                            }}
                          >
                            {attachment.Name}
                          </a>
                          <button
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = attachment.fileurl;
                              link.download = attachment.Name;
                              link.click();
                            }}
                            title="Download"
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "#2961EF",
                              marginLeft: "5px",
                              textDecoration: "underline",
                            }}
                          >
                            <FiDownload />
                          </button>
                        </li>
                      ))
                    ) : (
                      <span>No attachments available.</span>
                    )}
                  </ul>
                </div>
              </>
            ) : (
              <span>No documents available for selected year</span>
            )}
          </div>
        </div>
      ))}
      <table className={styles.commantable}>
        {/* Table Header */}
        <thead>
          <tr className={styles.tableHeaderRow}>
            <th className={styles.tableHeader}>Category</th>
            <th className={styles.tableHeader}>Debentures</th>
            <th className={styles.tableHeader}></th>
          </tr>
          <tr>
            <th className={styles.tableHeader}></th>
            <th className={styles.tableHeader}>Number of Debentures</th>
            <th className={styles.tableHeader}>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="3" className={styles.noDataRow} style={{textAlign:"center"}}>
                No debentures shareholding data available
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <React.Fragment key={index}>
                {/* Individual / Hindu Undivided Family */}
                {/* Reference Documents Section */}

                <tr className={styles.categoryRow}>
                  <td colSpan="3">1. Individual / Hindu Undivided Family</td>
                </tr>
                <tr>
                  <td>(i) Indian</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.indian_debent) || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {item.indian_debent_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(ii) Non-resident Indian (others)</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.NRI_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.NRI_debent_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(iii) Foreign national (other than NRI)</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.foreign_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.foreign_debent_percentage) || "-"}
                  </td>
                </tr>

                {/* Government */}
                <tr className={styles.categoryRow}>
                  <td colSpan="3">2. Government</td>
                </tr>
                <tr>
                  <td>(i) Central Government</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.central_gov_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.central_gov_debent_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(ii) State Government</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.state_gov_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.state_gov_debent_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(iii) Government companies</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.gov_companies_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.gov_companies_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Insurance companies */}
                <tr>
                  <td>3. Insurance companies</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.insurance_companies_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.insurance_companies_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Banks */}
                <tr>
                  <td>4. Banks</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.banks_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.banks_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Financial institutions */}
                <tr>
                  <td>5. Financial institutions</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.financial_instutions_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.financial_instutions_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Foreign institutional investors */}
                <tr>
                  <td>6. Foreign institutional investors</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.foreign_instutions_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.foreign_instutions_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Mutual funds */}
                <tr>
                  <td>7. Mutual funds</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.mutual_funds_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.mutual_funds_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Venture capital */}
                <tr>
                  <td>8. Venture capital</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.venture_capital_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.venture_capital_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Body corporate (not mentioned above) */}
                <tr>
                  <td>9. Body corporate (not mentioned above)</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.body_corporate_capital_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.body_corporate_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Others */}
                <tr>
                  <td>10. Others</td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.others_capital_debent)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.others_debent_percentage || "-"}
                  </td>
                </tr>

                {/* Total */}
                <tr>
                  <td>Total</td>
                  <td className={styles.tableCell}>
                    {item.total_debents || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatNumber(item.total_debents_percentage)}
                  </td>
                </tr>
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className={styles.container}>
      {/* Show subscription message if not subscribed */}
      {!isSubScribe && (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {/* Promoters Section */}
      {isSubScribe && (
        <>
          <h3 className={styles.highlet_text}>
            <div onClick={() => toggleSection("promoters")}>
              {openSections.promoters ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </div>
            {/* Promoters - 31 Mar, {selectedYearPromoters || "-"*/}
            Promoters
            {promotersData.length > 0 &&
              selectedYearPromoters &&
              ` - 31 Mar, ${selectedYearPromoters}`}
            {/* Year Selection Dropdown */}
            {promotersData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  id="year-select-promoters"
                  value={selectedYearPromoters}
                  onChange={(e) => setSelectedYearPromoters(e.target.value)}
                >
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </h3>

          {openSections.promoters && (promotersData.length > 0 || true) ? (
            <>{renderTable(promotersData)}</>
          ) : openSections.promoters && promotersData.length === 0 ? (
            <p className={styles.noDataRow}>No data available for Promoters</p>
          ) : null}
        </>
      )}

      {/* Public/Other Than Promoters Section */}
      {isSubScribe && (
        <>
          <h3 className={styles.highlet_text}>
            <div onClick={() => toggleSection("publicOtherThanPromoters")}>
              {openSections.publicOtherThanPromoters ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </div>
            {/* Public/Other Than Promoters -  31 Mar, {selectedYearPublic || "-"}
             */}
            Public/Other Than Promoters
            {promotersData.length > 0 &&
              selectedYearPromoters &&
              ` - 31 Mar, ${selectedYearPromoters}`}
            {promotersData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  id="year-select-public"
                  value={selectedYearPublic}
                  onChange={(e) => setSelectedYearPublic(e.target.value)}
                >
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </h3>

          {openSections.publicOtherThanPromoters &&
          (publicOtherThanPromotersData.length > 0 || true) ? (
            <>{renderTable(publicOtherThanPromotersData)}</>
          ) : openSections.publicOtherThanPromoters &&
            publicOtherThanPromotersData.length === 0 ? (
            <p className={styles.noDataRow}>
              No data available for Public/Other Than Promoters
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}

export default Debenturesshareholdingtable;
